// v0.6.10 — CalcLevelGateCta: the missing affordance on a calc-level gate.
//
// A calc-level Family B flag (see api/_review_taxonomy.CALC_LEVEL_FLAGS)
// blocks the WHOLE calculation and cannot be cleared from the row it is
// surfaced on. v0.6.10 correctly stopped offering a per-row decision for
// those groups -- but replaced it with nothing at all, leaving the
// operator a red blocking card whose "What to do" text names a
// destination with no way to get there. This restores an action.
//
// ADMIN gets a link straight to Settings -> Rate tables, deep-linked to
// the pending-acks panel that actually clears the gate. OPERATOR cannot
// resolve it (RatePendingAcksPanel is ADMIN-only and the underlying
// endpoints enforce the same), so they get told who can, rather than
// being sent to a tab where the panel renders as nothing.
//
// Uses react-router <Link>, never <a href>: a full page load drops the
// in-progress workflow session (same trap documented in
// AddRegistrationCta.jsx / RegistrationsWarning.jsx).
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowSquareOut, Info } from "@phosphor-icons/react";
import { useAuth } from "../auth/AuthContext";

export const CalcLevelGateCta = () => {
  const { t } = useTranslation();
  const { admin } = useAuth();
  const isAdmin = (admin?.role || "").toUpperCase() === "ADMIN";

  if (!isAdmin) {
    return (
      <div
        data-testid="calc-level-gate-operator-note"
        className="mt-2 flex items-start gap-2 text-[11px] text-slate-600 dark:text-slate-300"
      >
        <Info size={12} weight="bold" className="mt-0.5 shrink-0" />
        <span>{t("ui.review_grouped.calc_level_operator_note")}</span>
      </div>
    );
  }

  return (
    <Link
      to="/settings?tab=rate_tables#rate-pending-acks"
      data-testid="cta-calc-level-gate"
      className="inline-flex items-center gap-1.5 mt-2 bg-red-600 hover:bg-red-700 text-white font-semibold text-[10px] px-3 py-2 rounded-full shadow-lg shadow-red-500/20"
    >
      <ArrowSquareOut size={11} weight="bold" />
      {t("ui.review_grouped.calc_level_cta")}
    </Link>
  );
};
